// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1WYO1","notes":"Notes_notes__2ucgg"};